import React from "react";
import { Link } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { api, getToken } from "../software/api";

// Wraps a route so only a signed-in store_admin can see it (used to hide the
// detailed countertop manufacturing / engineering pages from NDA visitors).
export default function AdminOnly({ children, title = "This page is restricted" }) {
  const [access, setAccess] = React.useState("loading");

  React.useEffect(() => {
    let active = true;
    (async () => {
      if (!getToken()) { if (active) setAccess("denied"); return; }
      try {
        const me = await api("GET", "/auth/me");
        if (active) setAccess(me.role === "store_admin" ? "admin" : "denied");
      } catch (e) { if (active) setAccess("denied"); }
    })();
    return () => { active = false; };
  }, []);

  if (access === "admin") return children;

  return (
    <div className="min-h-screen bg-slate-100" data-testid="admin-only-gate">
      <div className="mx-auto max-w-md px-5 py-24 text-center">
        {access === "loading" ? (
          <p className="inline-flex items-center gap-2 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Checking access…</p>
        ) : (
          <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
            <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-900 text-white"><Lock className="h-5 w-5" /></span>
            <h1 className="font-display text-xl font-bold text-slate-900">{title}</h1>
            <p className="mt-2 text-sm text-slate-600">The detailed engineering &amp; manufacturing documents are held under NDA and shared on request only. Please sign in as admin, or return to the proposal.</p>
            <div className="mt-5 flex items-center justify-center gap-2">
              <Link to="/software" data-testid="admin-only-login" className="inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-sky-700 text-white text-sm font-semibold px-5 py-2.5 transition-colors"><Lock className="h-4 w-4" /> Admin login</Link>
              <Link to="/proposal" className="inline-flex items-center rounded-full border border-slate-300 text-slate-700 text-sm font-semibold px-5 py-2.5 hover:bg-slate-50 transition-colors">Back to proposal</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
